import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import HttpMethodChip from "../common/Chip";

const MenuEntry = ({ entry, browserUri, className = "", onMobileClose }) => {
  const isSelected = browserUri === entry.uri;

  const linkTo = entry.uri;

  const icon = isSelected ? <ChevronRightRoundedIcon className={`entry-icon ${isSelected ? 'selected' : ''}`} /> : null;

  const handleClick = () => {
    if (onMobileClose) onMobileClose();
  };

  return (
    <Link
      to={`/${linkTo}`}
      key={entry.uri}
      onClick={handleClick}
      className="menu-entry-link"
    >
      <Box
        className={`${className} menu-entry ${isSelected ? 'selected' : ''}`}
      >
        <Box className="entry-content">
          <Typography
            variant="body2"
            noWrap
            className={`entry-title ${isSelected ? 'selected' : ''}`}
          >
            {entry.title}
          </Typography>

          {entry.httpMethod && (
            <Box className="method-chip-container">
              <HttpMethodChip label={entry.httpMethod} />
            </Box>
          )}
        </Box>

          {icon}
      </Box>
    </Link>
  );
};

export default MenuEntry;